module.exports = __webpack_public_path__ + "img/qifeng.a2c47364.png";